<template>
  <div
    v-if="getloadedMenu"
    class="mobile-wrapper mb-4 pb-4 shoppingcart-wrapper"
  >
    <div :class="showNewUi && 'new-cart-content'">
      <div :class="showNewUi ? 'new-fixed-banner' : 'fixed-banner'">
        <div class="container-fluid banner-alt">
          <div class="row">
            <div class="col-6 banner-title">
              <span class="material-icons md-36" @click="goOrder"
                >keyboard_arrow_left</span
              >
              <span class="title-text" @click="goOrder">
                {{ $t("message.yourOrder") }}
              </span>
            </div>
            <div class="btn col-6 text-right">
              <a @click="clearAllOrders()" :style="mobileStyles.LinkColorTxt">
                {{ $t("message.clearAll") }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- fixed-banner-double -->
      <div class="content-padding" />

      <div class="container mt-2">
        <div
          v-if="wholeOrderDiscount && wholeOrderDiscountMessage"
          class="row cart-items"
        >
          <div :style="mobileStyles.successMsg" class="discount-container">
            {{ wholeOrderDiscountMessage }}
          </div>
        </div>
      </div>
      <div class="container-fluid mt-1">
        <TransitionGroup v-if="showSharedCart" name="list">
          <div v-for="(name, index) in getPeople" :key="index">
            <b style="font-size: larger; color: blue"
              >{{ name === getUser ? "My Order" : `${name}'s Order` }}
            </b>
            <div v-for="(item, idx) in getSharedCart[name].products" :key="idx">
              <cart-item :cart-item="item" :removeButton="name === getUser" />
            </div>
          </div>
        </TransitionGroup>
        <TransitionGroup v-else :name="showNewUi ? 'list' : ''">
          <template v-for="(item, index) in cartItems">
            <cart-item :key="index" :cart-item="item" />
          </template>
        </TransitionGroup>
      </div>

      <div class="col-sm-12" v-if="showRedemptionButton">
        <div
          @click="addReedemption()"
          class="btn btn-block redeem-btn mb-2"
          :style="mobileStyles.customButtonColour"
        >
          {{ RedemptionButtonText }}
        </div>
      </div>
    </div>
    <!-- /cart items -->
    <footer
      v-if="!showMobileOtpModal"
      :class="showNewUi ? 'new-cart-footer' : 'cart-footer'"
    >
      <div :class="showNewUi && 'new-fixed-footer'" class="container-fluid">
        <div
          v-if="cartItems.length > 0 && cartValue > 0"
          class="row mcart-totals"
        >
          <div class="container" v-if="!showNewUi">
            <span style="color: #55a7ff">{{
              $t("message.haveDiscountCode")
            }}</span>
          </div>

          <div v-if="showNewUi" class="container-fluid" @click="openCoupon">
            <button
              class="coupon-button border-0 btn btn-secondary btn-lg btn-block rounded-lg font-16 d-flex align-items-center justify-content-center"
              style="height: 48px"
              type="button"
            >
              <span style="color: #212529" v-if="couponIsApplied">
                {{ $t("message.couponApplied") }}
              </span>

              <span style="color: #212529" v-else>
                {{ $t("message.addCouponCode") }}
              </span>
            </button>
          </div>

          <CouponComponent
            v-else
            ref="couponComponent"
            :ForMobile="true"
            :className="'mcart-totals'"
            :qrcode="qrcode"
          ></CouponComponent>
        </div>

        <div
          class="row mcart-total d-flex justify-content-between"
          v-if="showNewUi"
        >
          <div :class="getPoints ? 'col-6' : 'col-8'">
            {{ totalLabel }}
          </div>
          <div v-if="getPoints" class="row" style="padding-right: 15px">
            <div>
              {{ (totalPrice + totalTipValue) | formatMoney(currencySign) }}
            </div>
            <div class="text-success points" v-if="(storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints)">
              ({{ Math.floor(getPoints) | formatNumber }}
              {{ loyaltyUnit(Math.floor(getPoints)) }})
            </div>
          </div>
          <div v-else class="col-4 mtotal-price">
            {{ (totalPrice + totalTipValue) | formatMoney(currencySign) }}
          </div>
        </div>

        <div class="row mcart-totals" v-if="!showNewUi">
          <div class="col-6">
            {{ $t("message.subtotal") }}
            {{ $t("message.exclude", { taxLabel }) }}
          </div>
          <div class="col-6 mtotal-price">
            {{ subtotalPrice | formatMoney(currencySign) }}
          </div>
        </div>
        <div
          class="row mcart-totals"
          :class="showNewUi && 'mcart-total-new-width'"
        >
          <div class="col-6">
            {{ taxLabel }}
          </div>
          <div class="col-6 mtotal-price">
            {{ totalGst | formatMoney(currencySign) }}
          </div>
        </div>
        <div
          v-if="showDelivery"
          class="row mcart-totals"
          :class="showNewUi && 'mcart-total-new-width'"
        >
          <div class="col-6">{{ $t("message.delivery") }}</div>
          <div class="col-6 mtotal-price">
            {{ deliveryFee | formatMoney(currencySign) }}
          </div>
        </div>
        <div
          v-if="discount"
          :class="showNewUi && 'mcart-total-new-width'"
          class="row mcart-totals"
        >
          <div class="col-6">{{ $t("message.discount") }}</div>
          <div class="col-6 mtotal-price">
            {{ discount | formatMoney(currencySign) }}
          </div>
        </div>
        <div
          class="row mcart-totals"
          :class="showNewUi && 'mcart-total-new-width'"
        >
          <div class="col-6">{{ $t("message.bankSurcharge") }}</div>
          <div class="col-6 mtotal-price">
            {{ getSurchargeBankAmount | formatMoney(currencySign) }}
          </div>
        </div>
        <div
          v-if="getSurchareHolidayName"
          class="row mcart-totals"
          :class="showNewUi && 'mcart-total-new-width'"
        >
          <div class="col-6">{{ getSurchareHolidayName }}</div>
          <div class="col-6 mtotal-price">
            {{ getSurchargeHolidayAmount | formatMoney(currencySign) }}
          </div>
        </div>

        <div
          v-show="tipsEnabled && totalTipValue"
          :class="showNewUi && 'mcart-total-new-width'"
          class="row mcart-totals"
        >
          <div class="col-6">{{ $t("message.tipAmount") }}</div>
          <div class="col-6 mtotal-price">
            {{ totalTipValue | formatMoney(currencySign) }}
          </div>
        </div>

        <div v-if="isEatIn && tipsEnabled && totalPrice">
          <div
            v-if="!getTotalTipValue"
            class="row mcart-totals"
            :class="showNewUi && 'mcart-total-new-width'"
            @click="setInitialTip"
          >
            <div class="col-6 text-primary">{{ $t("message.addTip") }}</div>
          </div>
          <div
            v-else
            class="row mcart-totals"
            :class="showNewUi && 'mcart-total-new-width'"
            @click="setInitialTip"
          >
            <div class="col-6 text-primary">{{ $t("message.editTip") }}</div>
          </div>
        </div>
        <div
          class="row mcart-total d-flex justify-content-between"
          v-if="!showNewUi"
        >
          <div :class="getPoints ? 'col-6' : 'col-8'">
            {{ totalLabel }}
          </div>
          <div v-if="getPoints" class="row" style="padding-right: 15px">
            <div>
              {{ (totalPrice + totalTipValue) | formatMoney(currencySign) }}
            </div>
            <div class="text-success points" v-if="(storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints)">
              ({{ Math.floor(getPoints) | formatNumber }} pts)
            </div>
          </div>
          <div v-else class="col-4 mtotal-price">
            {{ (totalPrice + totalTipValue) | formatMoney(currencySign) }}
          </div>
        </div>

        <div
          v-if="!exceedMinPurchase && !menuUnAvailable"
          class="p-2 text-danger text-center"
        >
          {{ $t("message.minimumPurchaseIs") }}
          {{ minPurchase | formatMoney(currencySign) }}
        </div>
        <div
          v-show="menuUnAvailable && store.ClosingStoreMessage"
          class="p-2 text-danger text-center"
          v-html="store.ClosingStoreMessage"
        ></div>
        <div
          v-show="menuUnAvailable && !store.ClosingStoreMessage"
          class="p-2 text-danger text-center"
        >
          {{ $t("message.CurrentlyNotTakingOnlineOrders") }}
        </div>
      </div>
      <transition :name="showNewUi ? 'fade' : ''">
        <div
          v-if="shouldDisplayFooter"
          :class="showNewUi && 'background-color: #F6F6F6'"
          class="extras-footer"
        >
          <div class="cart-btn-group">
            <router-link
              :class="showNewUi ? 'new-btn-cancel' : 'btn-cancel'"
              :style="getCancelButtonStyle()"
              :to="{
                name: 'store',
                params: {
                  storeid: $route.params.storeid,
                  storename: $route.params.storename,
                },
              }"
              class="btn"
              >{{ $t("message.cancel") }}
            </router-link>
            <button
              :class="{
                disabled: orderDisbaled ? 'disabled' : '',
                'btn-primary': !showNewUi,
                'new-btn-primary': showNewUi,
              }"
              :disabled="
                (cartItems.length === 0 && !sharedCartOrderAvailable) ||
                orderDisbaled ||
                menuUnAvailable === true
              "
              :style="getConfirmButtonStyle()"
              class="btn"
              @click="wastageReport ? showWastageAlert() : navigateToCheckout()"
            >
              {{
                menuUnAvailable
                  ? $t("message.storeClosed")
                  : IsSaveOrder
                  ? $t("message.placeOrder")
                  : $t("message.checkout")
              }}
            </button>
          </div>
        </div>
      </transition>
    </footer>

    <modal
      ref="redemptionModal"
      v-if="showRedemption"
      full-header
      @close="closeModal"
      hide-footer
    >
      <template slot="body">
        <div
          style="
            height: calc(100vh - 150px);
            overflow-y: auto;
            margin-bottom: 50px;
          "
        >
          <Modifiers
            @canceled="closeModal"
            :product="selectedReedemption.product"
            :modifiers="selectedReedemption.modifiers"
            :product-id="selectedReedemption.productId"
            :price-trigger="getFirstValidRedemptionRule"
            @updated="selectRollIntoModiefiers"
            :is-submodifier="true"
            :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>
    <modal
      v-if="ShowRorderMessage"
      ref="Reordermodal"
      full-header
      @close="closeReorderModal"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ $t("message.reorder") }}</h2>
          </div>
          <p class="py-4">{{ $t("message.ReorderMessage") }}</p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index: 2">
          <button
            class="privacy-btn pull-right"
            :style="buttonStyles"
            data-dismiss="modal"
            type="button"
            @click="closeReorderModal()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>

    <modal
      ref="mobileOtpModal"
      v-if="showMobileOtpModal"
      :canBeDismissed="false"
      full-header
      @close="() => (this.showMobileOtpModal = false)"
      :hideFooter="true"
      :fullScreen="true"
    >
      <template slot="body">
        <checkout-otp
          @closeMobileOtpModal="
            () => {
              this.showMobileOtpModal = false;
            }
          "
          class="bg-white"
          @checkout="closeModalMobileAndCheckout"
        />
      </template>
    </modal>

    <!-- Modal -->

    <tips-bottom-sheet
      v-if="tipsEnabled"
      ref="myBottomSheet"
      :navigate-to-checkout="navigateToCheckout"
      :select-tip="selectTip"
      :selectCustomTip="selectCustomTip"
      :store-closed="
        cartItems.length === 0 || orderDisbaled || menuUnAvailable === true
      "
      :tip-selected="tipSelected"
      :tips="tips"
      :tips-value="tipsValue"
    />

    <!--   coupon bottom sheet -->
    <vue-bottom-sheet ref="couponBottomSheet" :rounded="true">
      <div style="max-width: 100vw; max-height: 30vh">
        <div class="container-fluid" style="overflow-x: hidden">
          <div
            class="modal-close-button d-flex align-items-center"
            @click="closeCoupon"
          >
            <span class="material-icons pl-2">close</span>
          </div>
          <p
            v-if="!couponIsApplied"
            class="text-center"
            style="font-size: 1.2em; font-weight: 600"
          >
            {{ $t("message.addCouponCode") }}
          </p>

          <p
            v-else
            class="text-center"
            style="font-size: 1.2em; font-weight: 600"
          >
            {{ $t("message.couponCode") }}
          </p>

          <div style="margin-left: -0.8em">
            <CouponComponent
              ref="couponComponent"
              :ForMobile="true"
              :className="'mcart-totals'"
              :qrcode="qrcode"
              @closeModal="closeCoupon"
            ></CouponComponent>
          </div>
        </div>
      </div>
    </vue-bottom-sheet>
    <paylater-alert
      :type="3"
      v-if="wastageAlertEnabled"
      @confirmed="navigateToCheckout()"
    ></paylater-alert>
    <block-time-alert
      v-if="blockTimeAlertEnabled"
      :remainingTime="remainingTime"
      :hideBlockModel="hideBlockModel"
    >
    </block-time-alert>
  </div>
  <progressindicator v-else style="opacity: 0.4"></progressindicator>
</template>
<script>
import CartItem from "./CartItemMobile";
import CouponComponent from "./CouponComponent";
import modal from "../../modal";
import shared from "../../../sharedscripts/shop/shopping-cart/ShoppingCart.js";
import Modifiers from "../products/Modifiers.vue";
import Progressindicator from "../../progressindicator";
import uuid from "uuid/v1";
import { getOrderHistory } from "../../../api/services/orderService.js";
import { mapGetters, mapActions } from "vuex";
import TipsBottomSheet from "@/components/tipsBottomSheet";
import { getTrackingOrders } from "@/api/services/userService";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import CheckoutOtp from "@/components/shared/checkoutOtp";
import { orderTypeHelper } from "@/api/helpers/orderTypeHelper";
import paylaterAlert from "../../shared/paylaterAlert.vue";
import { logger } from '../../../api/Logger';
import { readProductData } from "../../../api/helpers/rtdbHelper";
import { isiOS, sleep } from '../../../api/helpers/commonHelpers';
import blockTimeAlert from '../../shared/blockTimeAlert';

export default {
  name: "ShoppingCart",
  components: {
    TipsBottomSheet,
    CartItem,
    CouponComponent,
    modal,
    Modifiers,
    Progressindicator,
    VueBottomSheet,
    CheckoutOtp,
    paylaterAlert,
    blockTimeAlert,
  },
  props: {
    orderType: {
      type: Number,
      default: 3,
    },
    qrcode: {
      type: String,
      default: "",
    },
    orderid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      displayFooter: false,
      store: {},
      timerId: null,
      minPurchase: 0,
      dpTimeIsSet: true,
      IsInOperationMessage: null,
      selectedReedemption: null,
      showRedemption: false,
      IsSaveOrder: false,
      ShowRorderMessage: false,
      tips: [
        {
          id: 0,
          percentName: "No Tip",
          percentValue: 0,
        },
        {
          id: 1,
          percentName: "5%",
          percentValue: 5,
        },
        {
          id: 2,
          percentName: "10%",
          percentValue: 10,
        },
        {
          id: 3,
          percentName: "15%",
          percentValue: 15,
        },
      ],

      showMobileOtpModal: false,
      wastageAlertEnabled: false,
      blockTimeAlertEnabled: false,
      remainingTime: { minutes: 0, seconds: 0 },
      // if user has not added tips we ask them to add
      // if no tips toggle this to prevent user stuck from navigating to checkout
      // tipsModalOpened: false,
    };
  },
  created() {
    this.store = this.selectedCompany;
    this.validateCardAndRules();
    try {
      this.restoreListener(this.store.ID, this.getSharedCartProps.table) 
    } catch (error) {
      console.log('failed to restore the listener')
    }
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "viewConfig",
      "getStoreTimeSettingsClosed",
      "getSelectedMenuType",
      "getSharedCart",
      "showSharedCart",
      "getSharedCartProps",
      "currentStoreDoc",
      "coupons",
      "getUser",
      "mobileStyles",
      "getPeople",
      "getSharedCartSingleOrder",
      "totalGst",
    ]),
    taxIncludedLabel() {
      return this.isIndonesian
        ? this.$t("message.taxIncluded")
        : this.$t("message.gstIncluded");
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
    tipsEnabled() {
      return this.viewConfig.TipsEnabled;
    },
    getTotalTipValue() {
      return this.totalTipValue;
    },

    shouldDisplayFooter() {
      return this.displayFooter;
    },

    couponIsApplied() {
      return this.coupons && this.coupons.length;
    },
    isEatIn() {
      return orderTypeHelper.isDineIn();
    },
    sharedCartOrderAvailable() {
      return !this.getSharedCartSingleOrder && this.getPeople.length;
    },
  },
  watch: {
    selectedCompany(newValue) {
      this.store = newValue;
      this.validateCardAndRules();
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    },
    cartItems: {
      handler: function (newValue) {
        this.fixRedemptionQuantity(newValue);
      },
      deep: true,
    },
  },
  async mounted() {
    window.addEventListener('focus', this.handleFocus);
    if (isiOS()) {
      window.addEventListener('pageshow', this.handleVisibilityChange);
    } else {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }
    // fix laggy animation on page load
    setTimeout(() => {
      this.displayFooter = true;
    }, 300);

    this.setShowDeliveryFee(true);
    let coupon = window.localStorage.getItem("coupon");
    if (coupon) {
      this.$refs.couponComponent.applyCoupon(coupon);
    }
    if (sessionStorage.getItem("paymenttype") == "saveorder")
      this.IsSaveOrder = true;
    if (this.orderid) {
      var that = this;
      let odata = localStorage.getItem(this.store.ID + "-OrdersDatas");
      let OrdersData = odata != null ? JSON.parse(odata) : [];

      let savedorder = OrdersData.find(function (x) {
        return x.UDID == that.orderid;
      });
      if (savedorder) {
        that.clearAllOrders();
        that.SetOrder(savedorder, that);
        that.updateShoppingCartItems();
        if (savedorder.OrderItems.length > that.cartItems.length)
          that.ShowRorderMessage = true;
      } else {
        getOrderHistory(that.user.id, that.orderid)
          .get()
          .then(async (result) => {
            if (result.exists) {
              result = result.data();
              that.clearAllOrders();
              await that.SetOrder(result, that);
              that.updateShoppingCartItems();
              that.computeRules();
              if (result.OrderItems.length > that.cartItems.length) {
                that.ShowRorderMessage = true;
              }
            }
          });
      }
    }

    // tips only for dine in. Clear tips for other order typed
    if (!this.isEatIn) {
      this.clearTip();
    }

    if (this.tipsEnabled && this.isEatIn) {
      // stops staggering on page load
      setTimeout(() => {
        this.openTips();
      }, 800);
    }

    // perform the tips logic only if conditions below are net
    if (
      !this.isBranded() &&
      this.user &&
      this.showNewUi &&
      this.tipsEnabled &&
      this.isEatIn
    ) {
      // fetch info of previous tracking order
      const response = await getTrackingOrders(
        this.user.id,
        this.$route.params.storeid
      ).get();
      if (!response || !response.docs.length) return;

      const data = response.docs[0].data();
      if (!data) return;

      const { TipAmount, TotalTax, TotalExcludingTax } = data;
      if (!TipAmount) {
        return;
      }

      this.totalTipValue = TipAmount;

      // get the percentage of the tip applied for previous order
      const tipPercentPrevious =
        (TipAmount / (TotalTax + TotalExcludingTax)) * 100;

      // preselect same tip percent for current order
      const tipSelected = this.tips.find(
        (x) => x.percentValue == tipPercentPrevious
      );

      if (tipSelected) {
        // this.tipSelected = tipSelected.id;
        this.addTip(tipSelected.percentValue);
      }
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    if (isiOS()) {
      window.removeEventListener('pageshow', this.handleVisibilityChange);
    } else {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    window.removeEventListener('focus', this.handleFocus);
  },
  methods: {
    ...mapActions(["clearCart"]),
    ...shared.methods,
    clearAllOrders() {
      this.cartItems.forEach((cartitem) => {
        this.REMOVE_CART_ITEM({
          item: cartitem,
          sharedcart: this.showSharedCart,
          user: this.getSharedCartProps.user,
          table: this.getSharedCartProps.table,
          storeId: this.currentStoreDoc.ID,
        });
        this.applyPriceTriggers();
      });
      this.clearTip();
    },
    closeReorderModal() {
      this.$refs.Reordermodal.hideModal();
      this.ShowRorderMessage = false;
    },
    SetOrder(order, ins) {
      var that = ins;
      order.OrderItems.forEach((orderitem) => {
        var product = that.getProductOutcomeInfo(orderitem.Product_ID);
        if (product && product.Status != 3) {
          var modifiers = orderitem.OrderExtras.map((m) => {
            var result = {
              quantity: m.Quantity,
              TaxRate: m.UsingUnitPrice > 0 ? m.FinalTax / m.UsingUnitPrice : 0,
              Price: m.UsingUnitPrice,
              ID: m.Extra_ID,
              Name: m.Name,
            };
            if (m.ChildrenOrderExtras)
              result.selectedSubmodifiers = m.ChildrenOrderExtras.map((m2) => {
                return {
                  quantity: m2.Quantity,
                  TaxRate:
                    m2.UsingUnitPrice > 0 ? m2.FinalTax / m2.UsingUnitPrice : 0,
                  Price: m2.UsingUnitPrice,
                  ID: m2.Extra_ID,
                  Name: m2.Name,
                };
              });
            return result;
          });
          that.Add_ProductItem({
            item: {
              id: orderitem.Product_ID,
              uniqueId: uuid(),
              code: product.ProductCode,
              name: product.Name,
              description: product.ShortDescription,
              photoUrl: product.PhotoUrl,
              tax: product.TaxRate,
              price: orderitem.UsingUnitPrice,
              categoryId: orderitem.CategoryId,
              categoryName: orderitem.CategoryName,
              IsMaxQuantityLevelEnabled: product.IsMaxQuantityLevelEnabled,
            },
            ProductCategoryIDs: product.ProductCategoryIDs,
            ProductTagIDs: product.ProductTagIDs,
            quantity: orderitem.Quantity,
            PreparationTime: product.PreparationTime,
            modifiers: modifiers,
            sharedcart: this.showSharedCart,
            user: this.getSharedCartProps.user,
            table: this.getSharedCartProps.table,
            storeId: this.currentStoreDoc.ID,
          });
        }
      });
      that.applyPriceTriggers();
    },
    getCancelButtonStyle() {
      var styles = [];
      styles.push(this.mobileStyles.btn);
      if (this.showNewUi) {
        styles.push({ opacity: "0.85", width: "30%", borderRadius: "5px" });
      }
      return styles;
    },

    getConfirmButtonStyle() {
      var styles = [];
      styles.push(this.mobileStyles.btn);
      if (this.showNewUi) {
        styles.push({
          backgroundColor: "#222222",
          width: "66%",
          marginLeft: "4%",
          borderRadius: "5px",
        });
      }
      return styles;
    },
    getPayLaterButtonStyle() {
      var styles = [];
      styles.push({
        "border-radius": "5px",
      });
      return styles;
    },
    // close mobile otp modal
    async closeModalMobileAndCheckout() {
      // pass isAuthorized flag if otp flow successful
      this.showMobileOtpModal = false;
      await this.redirectToCheckOut();
    },

    handleVisibilityChange() {
      if (document.visibilityState === 'visible' || isiOS()) {
        // The mobile device is unlocked
        if (this.showSharedCart) {
          this.executeCodeWhenUnlocked();
        }
      }
    },
    handleFocus() {
      // Handle the browser window regaining focus
      if (this.showSharedCart) {
        this.executeCodeWhenUnlocked();
      }
    },
    async executeCodeWhenUnlocked() {
      try {
        await sleep(3000)
        const data = await readProductData(this.getSharedCartProps.table, this.$route.params.storeid);
        if (!data) {
          this.clearCart();
          this.$router.push(`/store/${this.$route.params.storeid}`);
        }
        else {
          const names = Object.keys(data);
          if (!names.includes(this.getSharedCartProps.user)) {
            this.clearCart();
            this.$router.push(`/store/${this.$route.params.storeid}`);
          }
        } 
      } catch (error) {
        logger.log('shared cart', error, `/store/${this.$route.params.storeid}`, 'error', '', '');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.shoppingcart-wrapper {
  min-height: 0 !important;
  height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.new-cart-content {
  max-height: 67vh;
  min-height: 50vh;
  padding-bottom: 20%;
  //margin-bottom: 16rem;
  overflow-y: scroll;
}

.mcart-total-new-width {
  width: 98vw !important;
}

.coupon-button {
  border-radius: 12px;
  line-height: 22px;
  width: 100%;
  overflow: hidden;
  text-align: center;
  padding: 16px 0;
  background-color: #eceff1 !important;
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}

.new-fixed-footer {
  max-height: 25vh;
  min-height: 20vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
